import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { PrivateRoute } from "../Core/PrivateRoute";
import { PermissionEnum } from "../misc/api/ApiPermissionEnum";
import { EcgAnalysisSetScreen } from "./EcgAnalysisSetScreen";
import { EcgSessionScreen } from "./EcgSessionListScreen";

export const EcgRoot = () => {
    return (
        <Switch>
            <PrivateRoute path="/ecg/analysis" permissions={[PermissionEnum.OverreadECGSession, PermissionEnum.ReviewECGSession]}>
                <EcgAnalysisSetScreen />
            </PrivateRoute>
            <PrivateRoute path="/ecg" permissions={[PermissionEnum.AccessSingleECGSession]}>
                <EcgSessionScreen />
            </PrivateRoute>
        </Switch>
    );
}
